// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contain {
  display: flex;
  flex-direction: column;
  height: 100vh;
}

.main-content {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}

.table-containerOne {
  /* margin: 70px 70px; */
  /* margin-top: 200px; */
  margin-right: 20px;
}

.table-containerOne h2 {
  font-size: xx-large;
}

.search-containerOne {
  margin-right: 20px;
}

.search-containerOne input[type='text'] {
  padding: 10px;
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  width: 100%;
  color: black;
  outline: none;
}

.search-containerOne input[type='text']:hover,
.search-containerOne input[type='text']:focus {
  border: 2px solid #2865aa;
}

.table-heading {
  width: 100%;
  border-collapse: collapse;
  margin-top: 70px;

}

.table-heading th,
.table-heading td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.table-heading th {
  background-color: #f2f2f2;
}

.table-heading tr:nth-child(even) {
  background-color: #f9f9f9;
}

.sort-icon {
  margin-left: 4px;
}

.desktop-table {
  display: table;
  width: 100%;
}

.mobile-scroll-table {
  display: none;
}

.no-data {
  text-align: center;
  padding: 20px;
  font-weight: bold;
}

@media (max-width: 768px) {
  .table-containerOne {
    margin: 5px;
    margin-top: 0px;
  }

  .desktop-table {
    display: none;
  }
  .AddOneToOne {
    display: none;
  }

  .mobile-scroll-table {
    display: block;
    /* overflow-x: auto; ---------------------*/
    margin: 0;
    text-align: center;
    margin-top: 20px;
    font-size: 10px;
  }

  .mobile-scroll-table table {
    /* width: max-content; */
    border-collapse: collapse;
    margin: auto;
    min-width: 0px;
  }

  .mobile-scroll-table td {
    padding: 8px 10px;
    border: 1px solid #ddd;
    /* min-width: 120px; */
    text-align: center;
    white-space: nowrap;
  }

  .mobile-scroll-table td:first-child {
    position: sticky;
    left: 0;
    z-index: 3;
    background: #f2f2f2;
    font-weight: 600;
    text-align: center;
    vertical-align: middle;
    border-left: 1px solid #ddd !important;
    box-shadow: inset 1px 0 0 #ddd;
  }

  .search-containerOne input[type='text'] {
    padding: 10px;
    font-size: 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    width: 100%;
    color: black;
    outline: none;
  }
  
  .search-containerOne input[type='text']:hover,
  .search-containerOne input[type='text']:focus {
    border: 1px solid #2865aa;
    font-size: 10px;
  }

  .sort-iconm {
    margin-left: 4px;
    /* height: 11px; */
    /* width: 11px; */
    vertical-align: middle;
  }
}

@media (min-width: 769px) {
  .desktop-table {
    display: table;
    width: 100%;
  }

  .mobile-scroll-table {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/OneToOneReview.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;;AAElB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,2CAA2C;IAC3C,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,wBAAwB;IACxB,yBAAyB;IACzB,YAAY;IACZ,cAAc;EAChB;;EAEA;IACE,iBAAiB;IACjB,sBAAsB;IACtB,sBAAsB;IACtB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;IAChB,OAAO;IACP,UAAU;IACV,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,sBAAsB;IACtB,sCAAsC;IACtC,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,aAAa;EACf;;EAEA;;IAEE,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":[".contain {\n  display: flex;\n  flex-direction: column;\n  height: 100vh;\n}\n\n.main-content {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n}\n\n.table-containerOne {\n  /* margin: 70px 70px; */\n  /* margin-top: 200px; */\n  margin-right: 20px;\n}\n\n.table-containerOne h2 {\n  font-size: xx-large;\n}\n\n.search-containerOne {\n  margin-right: 20px;\n}\n\n.search-containerOne input[type='text'] {\n  padding: 10px;\n  font-size: 16px;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  width: 100%;\n  color: black;\n  outline: none;\n}\n\n.search-containerOne input[type='text']:hover,\n.search-containerOne input[type='text']:focus {\n  border: 2px solid #2865aa;\n}\n\n.table-heading {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 70px;\n\n}\n\n.table-heading th,\n.table-heading td {\n  border: 1px solid #ddd;\n  padding: 8px;\n  text-align: center;\n}\n\n.table-heading th {\n  background-color: #f2f2f2;\n}\n\n.table-heading tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.sort-icon {\n  margin-left: 4px;\n}\n\n.desktop-table {\n  display: table;\n  width: 100%;\n}\n\n.mobile-scroll-table {\n  display: none;\n}\n\n.no-data {\n  text-align: center;\n  padding: 20px;\n  font-weight: bold;\n}\n\n@media (max-width: 768px) {\n  .table-containerOne {\n    margin: 5px;\n    margin-top: 0px;\n  }\n\n  .desktop-table {\n    display: none;\n  }\n  .AddOneToOne {\n    display: none;\n  }\n\n  .mobile-scroll-table {\n    display: block;\n    /* overflow-x: auto; ---------------------*/\n    margin: 0;\n    text-align: center;\n    margin-top: 20px;\n    font-size: 10px;\n  }\n\n  .mobile-scroll-table table {\n    /* width: max-content; */\n    border-collapse: collapse;\n    margin: auto;\n    min-width: 0px;\n  }\n\n  .mobile-scroll-table td {\n    padding: 8px 10px;\n    border: 1px solid #ddd;\n    /* min-width: 120px; */\n    text-align: center;\n    white-space: nowrap;\n  }\n\n  .mobile-scroll-table td:first-child {\n    position: sticky;\n    left: 0;\n    z-index: 3;\n    background: #f2f2f2;\n    font-weight: 600;\n    text-align: center;\n    vertical-align: middle;\n    border-left: 1px solid #ddd !important;\n    box-shadow: inset 1px 0 0 #ddd;\n  }\n\n  .search-containerOne input[type='text'] {\n    padding: 10px;\n    font-size: 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    width: 100%;\n    color: black;\n    outline: none;\n  }\n  \n  .search-containerOne input[type='text']:hover,\n  .search-containerOne input[type='text']:focus {\n    border: 1px solid #2865aa;\n    font-size: 10px;\n  }\n\n  .sort-iconm {\n    margin-left: 4px;\n    /* height: 11px; */\n    /* width: 11px; */\n    vertical-align: middle;\n  }\n}\n\n@media (min-width: 769px) {\n  .desktop-table {\n    display: table;\n    width: 100%;\n  }\n\n  .mobile-scroll-table {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
